/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Placeholders_Searchsellers1Inputs */

const id_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari penjual...`)
};

const ms_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari penjual...`)
};

const da_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg efter sælgere...`)
};

const de_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufer durchsuchen...`)
};

const en_us2_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search sellers...`)
};

const es_es2_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar vendedores...`)
};

const es_mx2_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar vendedores...`)
};

const fil_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap ng mga nagbebenta...`)
};

const fr_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des vendeurs…`)
};

const it_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca venditori...`)
};

const hu_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eladók keresése...`)
};

const nl_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkopers zoeken...`)
};

const no_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk etter selgere...`)
};

const pl_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj sprzedawców...`)
};

const pt_br2_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar vendedores...`)
};

const pt_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar vendedores...`)
};

const ro_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută vânzători...`)
};

const fi_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae myyjiä...`)
};

const sv_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök säljare...`)
};

const vi_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm người bán...`)
};

const tr_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satıcıları ara...`)
};

const cs_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat prodejce...`)
};

const bg_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене на продавачи...`)
};

const ru_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск продавцов...`)
};

const uk_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук продавців...`)
};

const ar_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث عن بائعين...`)
};

const hi_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विक्रेता खोजें...`)
};

const th_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาผู้ขาย...`)
};

const ja_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売元を検索...`)
};

const zh_cn2_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索发行商...`)
};

const zh_hant1_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋發行商...`)
};

const ko_freebies_placeholders_searchsellers1 = /** @type {(inputs: Freebies_Placeholders_Searchsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매자 검색...`)
};

/**
* | output |
* | --- |
* | "Search sellers..." |
*
* @param {Freebies_Placeholders_Searchsellers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_placeholders_searchsellers1 = /** @type {((inputs?: Freebies_Placeholders_Searchsellers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Placeholders_Searchsellers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_placeholders_searchsellers1(inputs)
	if (locale === "ms") return ms_freebies_placeholders_searchsellers1(inputs)
	if (locale === "da") return da_freebies_placeholders_searchsellers1(inputs)
	if (locale === "de") return de_freebies_placeholders_searchsellers1(inputs)
	if (locale === "en-US") return en_us2_freebies_placeholders_searchsellers1(inputs)
	if (locale === "es-ES") return es_es2_freebies_placeholders_searchsellers1(inputs)
	if (locale === "es-MX") return es_mx2_freebies_placeholders_searchsellers1(inputs)
	if (locale === "fil") return fil_freebies_placeholders_searchsellers1(inputs)
	if (locale === "fr") return fr_freebies_placeholders_searchsellers1(inputs)
	if (locale === "it") return it_freebies_placeholders_searchsellers1(inputs)
	if (locale === "hu") return hu_freebies_placeholders_searchsellers1(inputs)
	if (locale === "nl") return nl_freebies_placeholders_searchsellers1(inputs)
	if (locale === "no") return no_freebies_placeholders_searchsellers1(inputs)
	if (locale === "pl") return pl_freebies_placeholders_searchsellers1(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_placeholders_searchsellers1(inputs)
	if (locale === "pt") return pt_freebies_placeholders_searchsellers1(inputs)
	if (locale === "ro") return ro_freebies_placeholders_searchsellers1(inputs)
	if (locale === "fi") return fi_freebies_placeholders_searchsellers1(inputs)
	if (locale === "sv") return sv_freebies_placeholders_searchsellers1(inputs)
	if (locale === "vi") return vi_freebies_placeholders_searchsellers1(inputs)
	if (locale === "tr") return tr_freebies_placeholders_searchsellers1(inputs)
	if (locale === "cs") return cs_freebies_placeholders_searchsellers1(inputs)
	if (locale === "bg") return bg_freebies_placeholders_searchsellers1(inputs)
	if (locale === "ru") return ru_freebies_placeholders_searchsellers1(inputs)
	if (locale === "uk") return uk_freebies_placeholders_searchsellers1(inputs)
	if (locale === "ar") return ar_freebies_placeholders_searchsellers1(inputs)
	if (locale === "hi") return hi_freebies_placeholders_searchsellers1(inputs)
	if (locale === "th") return th_freebies_placeholders_searchsellers1(inputs)
	if (locale === "ja") return ja_freebies_placeholders_searchsellers1(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_placeholders_searchsellers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_placeholders_searchsellers1(inputs)
	return ko_freebies_placeholders_searchsellers1(inputs)
});
export { freebies_placeholders_searchsellers1 as "freebies.placeholders.searchSellers" }